import { Address } from '@models/address';

export const buildAddressFromGoogleAddress = (placeDetails): Address => {
	const _street =
		placeDetails?.address_components
			?.filter(
				(add) =>
					add.types.includes('floor') ||
					add.types.includes('street_number') ||
					add.types.includes('route'),
			)
			.map((x) => x.long_name)
			.join(' ') ?? '';
	const _city =
		placeDetails?.address_components?.find((add) =>
			add.types.includes('locality'),
		)?.long_name ?? '';
	const _province =
		placeDetails?.address_components?.find((add) =>
			add.types.includes('administrative_area_level_1'),
		)?.short_name ?? '';
	const _postcode =
		placeDetails?.address_components?.find((add) =>
			add.types.includes('postal_code'),
		)?.long_name ?? '';
	const _country =
		placeDetails?.address_components?.find((add) =>
			add.types.includes('country'),
		)?.short_name ?? '';
	const _countryCode =
		placeDetails?.address_components?.find((add) =>
			add.types.includes('countryCode'),
		)?.short_name ?? '';

	return {
		unit: '',
		street: _street,
		city: _city,
		province: _province,
		postcode: _postcode,
		country: _country,
		countryCode: _countryCode,
		_geoloc: {
			lat: placeDetails.geometry?.location?.lat,
			lng: placeDetails.geometry?.location?.lng,
		},
	};
};

export const getGoogleMapUrlFromAddress = (address: Address): string =>
	`https://maps.google.com/?q=${address.street}%2C${address.city}%2C${address.province}%2C${address.country}%2C${address.postcode}&markers=color:red`;
